const resources = {
    showMore: 'Afficher plus',
    viewing: 'Affichage',
    results: 'résultats'
};

export default function getResource(label) {
    return resources[label];
}
